import { useFeature } from 'bv-hooks';
import withLazyLoad from 'bv-lazy-load';

const LazyUserInboxIcon = withLazyLoad()('userInboxIcon');

const LazyUserInboxIconComponent = () => {
  const [userInboxEnabled] = useFeature('customer_inbox');

  if (userInboxEnabled) return <LazyUserInboxIcon />;
  return null;
};

export default LazyUserInboxIconComponent;
